// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const maintenanceMode: boolean = false;
